import { render, staticRenderFns } from "./combinations.vue?vue&type=template&id=2117c702&"
import script from "./combinations.vue?vue&type=script&lang=js&"
export * from "./combinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports